import React from 'react';
import { Alert, Modal } from 'antd';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import {
  registrationStateTypes,
  registrationResultCodesMap,
  useRegistrationControllers,
  useRegistrationSubscribe,
} from '../../../../services/acceptanceRegistration';
import SelectOwner from './SelectOwner';
import FetchCurrentIntervalData from './FetchCurrentIntervalData';
import AddressDescription from './AddressDescription';
import IntervalDescription from './IntervalDescription';
import Checkboxes from './Checkboxes';
import ErrorBlock from './ErrorBlock';
import { useFormController } from '../../../../../../helpers/formManager';
import styles from './index.module.scss';

const SetupIntervalForRegistrationModal = () => {
  const { isOpen, props: { interval, targetDate, initialValues, alert } = {} } =
    useModalWatch({
      name: modalNames.setupIntervalForRegistration,
    });

  const saveState = useRegistrationSubscribe({
    type: registrationStateTypes.save,
  });

  const addressStatus = useRegistrationSubscribe({
    type: registrationStateTypes.address,
    selector: (state) => state.status,
  });

  const selectedOwnerStatus = useRegistrationSubscribe({
    type: registrationStateTypes.selectedOwner,
    selector: (state) => state.status,
  });

  const { setupIntervalModalHandlers } = useRegistrationControllers();
  const { onOk, onCancel, afterClose } = setupIntervalModalHandlers;

  const { control, handleSubmit } = useFormController({
    values: initialValues,
  });

  const afterCloseHandler = () => {
    afterClose();
  };

  return (
    <Modal
      centered
      title="Запись"
      visible={isOpen}
      maskClosable={false}
      onCancel={onCancel}
      onOk={handleSubmit(onOk)}
      afterClose={afterCloseHandler}
      confirmLoading={saveState.status === 'loading'}
      okText={getOkText(saveState)}
      okButtonProps={{
        disabled:
          addressStatus !== 'success' ||
          selectedOwnerStatus !== 'success' ||
          !interval?.id,
      }}
      destroyOnClose
    >
      <FetchCurrentIntervalData
        addressStatus={addressStatus}
        selectedOwnerStatus={selectedOwnerStatus}
      >
        <div className={styles.body}>
          <AddressDescription />
          <SelectOwner />
          <IntervalDescription interval={interval} targetDate={targetDate} />
          <Checkboxes withExpertId={interval?.withExpertId} control={control} />
          <ErrorBlock message={saveState.message} />
          {Boolean(alert) && <Alert message={alert} type="warning" />}
        </div>
      </FetchCurrentIntervalData>
    </Modal>
  );
};

export default SetupIntervalForRegistrationModal;

function getOkText(saveState) {
  const { status, code } = saveState;

  if (status === 'notAvailable') {
    return code === registrationResultCodesMap.roomRegistered
      ? 'Перезаписать'
      : 'Выбрать другой интервал';
  }

  return 'Ok';
}
